import { render, staticRenderFns } from "./ContratoSP2.vue?vue&type=template&id=28ec6929"
import script from "./ContratoSP2.vue?vue&type=script&lang=js"
export * from "./ContratoSP2.vue?vue&type=script&lang=js"
import style0 from "./ContratoSP2.vue?vue&type=style&index=0&id=28ec6929&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports